// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/styles/default/upc-common.less
// module id = 3233
// module chunks = 0